import { ROUTER_PATHS } from '@/lib/constants'
import { InspectionCornSchema } from '@eigtech/inspections-types'
import { ensureClaimCorn } from '@eigtech/shared-corn-helper'
import { InspectionDetail } from '@eigtech/ui-shared-inspections-web'
import { Container } from '@eigtech/ui/components/container'
import { createFileRoute, Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { z } from 'zod'

const Schema = z.object({
  claimNumber: z.string(),
  inspectionId: InspectionCornSchema,
})

export const Route = createFileRoute(
  '/_auth/claims/$claimNumber/_layout/inspections_/$inspectionId'
)({
  component: RouteComponent,
  parseParams: Schema.parse,
})

function RouteComponent() {
  const { claimNumber, inspectionId } = Route.useParams()

  return (
    <Container className="my-4 space-y-4">
      <Link
        className="text-primary inline-flex w-fit items-center gap-1.5 text-sm hover:underline"
        params={{ claimNumber }}
        to={ROUTER_PATHS.claimDetailInspections.route}
      >
        <ArrowLeft className="size-4" />
        Back to Inspections
      </Link>

      <InspectionDetail entityId={ensureClaimCorn(claimNumber)} inspectionId={inspectionId} />
    </Container>
  )
}
